import { i18n } from '@/plugins/i18n'

export const gatewayTypes = {
    PARDAKHTYARI: 0,
    PAYMAN: 1,
    IVR: 2,
    DEDICATED: 3,
    CARD_TO_CARD: 5,
}

export const pspTypes = (psp) => {
    switch (psp){
        case "novin":
            return "پرداخت نوین"
        case "irankish":
            return "ایران کیش"
        case "sepehr":
            return "سپهر"
        case "pasargad":
            return "پاسارگاد"
        case "asanpardakht":
            return "آسان پرداخت"
    }
}

export const gatewayTypeStr = {
    PARDAKHTYARI: i18n.t('gateway.gateway_types.pardakhtyari'),
    PAYMAN: i18n.t('gateway.gateway_types.payman'),
    IVR: i18n.t('gateway.gateway_types.ivr'),
    DEDICATED: i18n.t('gateway.gateway_types.dedicated'),
    get(type) {
        let type_str = null;
        Object.keys(gatewayTypes).forEach(function (item) {
            if(gatewayTypes[item] === type) {
                type_str = gatewayTypeStr[item]
            }
        })

        return type_str
    }
}

export const gatewayTypeVariant = (status) => {
    if(status === gatewayTypes.PARDAKHTYARI) {
        return 'success'
    }

    if(status === gatewayTypes.PAYMAN) {
        return 'info'
    }

    if(status === gatewayTypes.IVR) {
        return 'warning'
    }

    if(status === gatewayTypes.DEDICATED) {
        return 'primary'
    }

    return 'dark'
}

export const gatewayTypeUpdateUrl = (gatewayType, type = null) => {
    if(gatewayType === gatewayTypes.PARDAKHTYARI) {
        return '/gateways/update/'
    }

    if(gatewayType === gatewayTypes.PAYMAN) {
        return '/payman/update/'
    }

    if(gatewayType === gatewayTypes.IVR && type === 2) {
        return '/update-vip/'
    }

    if(gatewayType === gatewayTypes.IVR) {
        return '/ivr/update/'
    }
    if(gatewayType === gatewayTypes.CARD_TO_CARD) {
        return '/card-to-card/update/'
    }

    if(gatewayType === gatewayTypes.DEDICATED) {
        return '/dedicated/update/'
    }

    return ''
}